module.exports = __webpack_public_path__ + "img/location.f2fcf163.svg";